<template>
  <div class="py-1 space-y-1">
    <!-- Patient ID -->
    <div v-if="patientId">
      <span class="sensitive inline-block px-1.5 py-0.5 bg-blue-50 text-blue-700 rounded text-xs font-mono font-semibold">
        {{ patientId }}
      </span>
    </div>

    <!-- Patient Name -->
    <div v-if="lastName || firstName" class="sensitive text-sm text-gray-900">
      <span class="font-semibold">{{ lastName || '—' }}</span><span v-if="firstName" class="font-normal">, {{ firstName }}</span>
    </div>

    <!-- Date of Birth -->
    <div v-if="dob" class="sensitive flex items-center gap-1 text-xs text-gray-600">
      <span class="opacity-70">📅</span>
      <span>{{ formatDOB(dob) }}</span>
    </div>

    <!-- PCP -->
    <div v-if="pcp" class="sensitive flex items-center gap-1 text-xs text-gray-600">
      <span class="opacity-70">👨‍⚕️</span>
      <span class="truncate" :title="pcp">{{ truncatePCP(pcp) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientCompositeRenderer',
  props: ['params'],
  computed: {
    patientId() {
      return this.params.data?.metadata?.patient_identifier;
    },
    lastName() {
      return this.params.data?.metadata?.bene_last_name;
    },
    firstName() {
      return this.params.data?.metadata?.bene_first_name;
    },
    dob() {
      return this.params.data?.metadata?.bene_dob;
    },
    pcp() {
      return this.params.data?.metadata?.bene_pcp;
    }
  },
  methods: {
    formatDOB(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    truncatePCP(pcp) {
      if (!pcp) return '';
      if (pcp.length > 25) {
        return pcp.substring(0, 23) + '...';
      }
      return pcp;
    }
  }
}
</script>
